module.exports = __webpack_public_path__ + "static/media/sport-banner-casino.8ce02654.png";